(ns fablo-offers.common.components.language-selector
  (:require ["@chakra-ui/react" :as ch]
            [fablo-offers.common.lib.hooks :as hooks]
            [fablo-offers.common.lib.i18n :as i18n]
            [fablo-offers.common.tracking :as tracking]
            [rumext.alpha :as mf]))

(mf/defc lang-button [{:keys [sidebar-collapsed?]}]
  (let [current-lang (i18n/language)
        flag-icon (cond
                    (= current-lang "pl") "/img/flag-poland.svg"
                    (= current-lang "en") "/img/flag-united-kingdom.svg")]
    (hooks/use-translation)
    (mf/with-effect
      (tracking/register {:language (i18n/language)}))
    [:> ch/Box {:z-index 2}
     [:> ch/Menu {:placement "top" :offset [0 -73]}
      [:> ch/MenuButton
       {:as ch/Button
        :aria-label "Language"
        :variant :unstyled
        :padding 0}
       [:> ch/HStack {:spacing 2 :justify-content (when sidebar-collapsed? "center")}
        [:> ch/Image {:src flag-icon :w "24px"}]
        (when-not sidebar-collapsed?
          [:> ch/Text {:font-weight :semibold :font-size :md} (clojure.string/upper-case (i18n/language))])
        (when-not sidebar-collapsed?
          [:> ch/Image {:src "/img/arrow-down.svg"}])]]
      [:> ch/MenuList {:min-width "fit-content" :padding "0px" :border "0"}
       [:> ch/MenuOptionGroup
        {:type :radio
         :on-change #(i18n/change-language! %)
         :value (i18n/language)}
        [:> ch/MenuItemOption {:value "pl" :icon nil}
         [:> ch/HStack {}
          [:> ch/Image {:src "/img/flag-poland.svg" :w "24px"}]
          (when-not sidebar-collapsed?
            [:> ch/Text {:font-weight :semibold :font-size :md} "PL"])
          (when-not sidebar-collapsed?
            [:> ch/Image {:src "/img/arrow-up.svg"}])]]
        [:> ch/MenuItemOption {:value "en" :icon nil}
         [:> ch/HStack {}
          [:> ch/Image {:src "/img/flag-united-kingdom.svg" :w "24px"}]
          (when-not sidebar-collapsed?
            [:> ch/Text {:font-weight :semibold :font-size :md} "EN"])]]]]]]))
